@if (!adaptiveLayout.current.headerSubNavigationHidden) {
    @if (isMobilePhone && isMyBetsTabRedesignEnabled && (isMyBetsRoute$ | async)) {
        <div class="mybets-container">
            <ms-my-bets-sub-navigation [tabs]="tabs" (tabClick)="clickEvent($event)"></ms-my-bets-sub-navigation>
        </div>
    } @else {
        <ds-tabs-group
            msThemedTabs
            class="sub-nav-tab-alignment"
            scrollSpeed="slow"
            showBorderBottom="true"
            variant="horizontal"
            [scrollDistance]="200"
            [themedSize]="themedTabSize"
            [class.tab-with-button-alignment]="isLiveButtonEnabled"
            [size]="tabSize"
            [activeTab]="active.id.toString()"
            [scrollable]="true"
            [fullWidthTabs]="isFullWidth"
            [inverse]="tabInverse"
            (tabChanged)="selected($event)">
            @for (tab of tabs; track tab.id) {
                @if (tab.id !== subNavigation.LiveInSportPage) {
                    <ds-tab [name]="tab.id.toString()">
                        <ng-container *dsTabHeader>
                            <a [msLink]="tab.url" [vnSpeculativeLink]="tab.url!">
                                @if (tab.iconClass) {
                                    <vn-icon name="{{ tab.iconClass }}" slot="start" [size]="isLargeTab ? '24' : '16'"></vn-icon>
                                } @else if (tab.icon) {
                                    <vn-icon name="{{ tab.icon }}" class="resulted-icon" slot="start" [size]="isLargeTab ? '24' : '16'"></vn-icon>
                                }

                                {{ tab.title }}
                                @if (tab.count) {
                                    <ds-notification-bubble variant="primary" size="medium" slot="end">
                                        {{ tab.count }}
                                    </ds-notification-bubble>
                                }
                            </a>
                        </ng-container>
                    </ds-tab>
                } @else {
                    <ds-divider class="tab-separator" vertical="true" />
                    <button
                        ds-button
                        class="button-alignment"
                        size="large"
                        variant="flat-reduced"
                        kind="tertiary"
                        [inverse]="tabInverse"
                        (click)="click(tab)">
                        @if (tab.count) {
                            <ds-notification-bubble size="medium" slot="start" [variant]="isEpcotEnabled ? 'live' : 'primary'" [inverse]="tabInverse">
                                {{ tab.count }}
                            </ds-notification-bubble>
                        }
                        {{ tab.title }}
                        @if (tab.icon) {
                            <vn-icon name="{{ tab.icon }}" size="16" slot="end"></vn-icon>
                        }
                    </button>
                }
            }
        </ds-tabs-group>
    }

    @if (showDivider) {
        <ds-divider />
    }
}
